var modules_5e29803a = {"triggerButton":"MobileMenuBlock_module_triggerButton__04b75cd5","hidden":"MobileMenuBlock_module_hidden__04b75cd5","promoWrapper":"MobileMenuBlock_module_promoWrapper__04b75cd5","dropdown":"MobileMenuBlock_module_dropdown__04b75cd5","dropdownVisible":"MobileMenuBlock_module_dropdownVisible__04b75cd5"};
import "../../../assets/esm/components/MobileMenuBlock/src/MobileMenuBlock~DiF4P6lb.css";

export { modules_5e29803a as default };
//# sourceMappingURL=MobileMenuBlock.module.less.js.map
